import { type Gateway, useGateway } from '@ad-lucy/gateway-provider';
import { getAppConfig } from '@modules/config/appConfig';

type MfCreatorConfig = {
  API_ROOT: string;
  STAGE_HOST_PREVIEW?: string;
  CREATIVE_BUILDS_URL: string;
  CREATIVE_MANIFEST_URL: string;
  IMG_URL: string;
  THEME_URL: string;
  THEME_DEFAULT: string;
  QUICK_START_URL?: string;
  EXPORT_URL: string;
  FILE_URL: string;
};

type MfCreatorReturnProps = {
  gateway: Gateway;
  apiConfig: MfCreatorConfig;
};

export const useMfCreatorConfig = (): MfCreatorReturnProps => {
  const gateway = useGateway();
  const appConfig = getAppConfig();

  return {
    gateway,
    apiConfig: {
      THEME_URL: appConfig.THEME_URL,
      IMG_URL: appConfig.IMG_URL,
      FILE_URL: appConfig.FILE_URL,
      THEME_DEFAULT: appConfig.THEME_DEFAULT ?? '',
      API_ROOT: appConfig.API_ROOT,
      STAGE_HOST_PREVIEW: appConfig.STAGE_HOST_PREVIEW,
      EXPORT_URL: appConfig.EXPORT_URL,
      CREATIVE_BUILDS_URL: appConfig.CREATIVE_BUILDS_URL,
      CREATIVE_MANIFEST_URL: appConfig.CREATIVE_MANIFEST_URL,
    },
  };
};
